module.exports = __webpack_public_path__ + "img/home_learn.c052787e.png";